function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, forwardRef } from "react";
import { Table, Row, Col, Divider, Descriptions, Image } from "antd";
import moment from "moment";
import DocumentHeader from "./DocumentHeader";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RistourneDetails = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var bills = _ref.bills;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    listOfBills = _useState2[0],
    setListOfBills = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    billsArrayData = _useState4[0],
    setBillsArrayData = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    totalAmount = _useState6[0],
    setTotalAmount = _useState6[1];
  var cols = [{
    title: "Prescripteur",
    dataIndex: "prescriber",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "prescriber"
  }, {
    title: "Nº Facture",
    dataIndex: "bill_id",
    render: function render(text) {
      return /*#__PURE__*/_jsxs("span", {
        children: ["FEMG-", text]
      });
    },
    key: "bill_id"
  }, {
    title: "Montant (GNF)",
    dataIndex: "amount",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "amount"
  }];
  useEffect(function () {
    setBillsArrayData([]);
    bills.forEach(function (b) {
      var ta = 0;
      if (b.prescriber.has_ristourne == 0) return;
      var commission = 0;
      if (b.prescriber.has_ristourne == 0) return;
      b.bill_items.forEach(function (e) {
        if (e.business_account_medical_item.department.dcode == "RAD") commission = 25000;
        if (e.business_account_medical_item.department.dcode == "SCA") commission = 200000;
        if (e.business_account_medical_item.department.dcode == "HIS") commission = 100000;
        ta += commission;
      });
      if (commission != 0) setBillsArrayData(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          key: b.id,
          prescriber: b.prescriber.name,
          bill_id: b.id,
          amount: commission.toLocaleString("Fr")
        }]);
      });
      setTotalAmount(function (prev) {
        return prev + ta;
      });
    });
  }, []);
  return /*#__PURE__*/_jsx("div", {
    id: "printable",
    ref: ref,
    children: /*#__PURE__*/_jsxs("div", {
      className: "watermarked",
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(DocumentHeader, {
          title: "FICHE DES RISTOURNES"
        }), /*#__PURE__*/_jsx(Table, {
          size: "small",
          columns: cols,
          bordered: true,
          sticky: true,
          dataSource: billsArrayData,
          pagination: false
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Descriptions, {
          children: /*#__PURE__*/_jsx(Descriptions.Item, {
            valueStyle: {
              fontSize: "36px",
              fontWeigth: "bold"
            },
            label: /*#__PURE__*/_jsx("b", {
              children: "Total (GNF)"
            }),
            children: totalAmount.toLocaleString("fr")
          })
        })]
      })]
    })
  });
});
export default RistourneDetails;